import { Configuration, PopupRequest, IPublicClientApplication } from "@azure/msal-browser";

import { _clientSettings } from '../utils/client/client-settings';

// Config object to be passed to Msal on creation
export const _msalConfig: Configuration = {
    auth: {
        clientId: _clientSettings.clientId,
        authority: _clientSettings.authority,
        redirectUri: window.location.origin + '/login',
        navigateToLoginRequestUrl: false,
        postLogoutRedirectUri: window.location.origin
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const _loginRequest: PopupRequest = {
    scopes: [
        `api://${_clientSettings.clientId}/user_impersonation`
    ]
};

export const aquireToken = async (instance: IPublicClientApplication) => {
    const account = instance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    return await instance.acquireTokenSilent({
        ..._loginRequest,
        account: account
    });
}